import React from 'react';
import { Heading, Icon, Text } from '@tesla/design-system-react';
import * as TDSIcons from '@tesla/design-system-icons';
import classnames from 'classnames';
import useStickyHeader from '../../../Hooks/useStickyHeader.js';
import Styles from '../../SideNavigationBar.module.css.js';
import { useNavConfigContext } from '../../Context/index.js';

var SelectedTab = function SelectedTab() {
  var _useNavConfigContext = useNavConfigContext(),
    navConfig = _useNavConfigContext.navConfig,
    setOpenMobileMenu = _useNavConfigContext.setOpenMobileMenu,
    translations = _useNavConfigContext.translations,
    isMobileView = _useNavConfigContext.isMobileView,
    activeTab = _useNavConfigContext.activeTab,
    loading = _useNavConfigContext.loading;
  var isSticky = useStickyHeader();
  var selectedTab = (navConfig === null || navConfig === void 0 ? void 0 : navConfig.find(function (tab) {
    return activeTab ? tab.label === activeTab : window.location.href.includes(tab.externalUrl);
  })) || {};
  var iconName = selectedTab.iconName,
    customIcon = selectedTab.customIcon;
  var icon = iconName;
  if (!iconName && !customIcon) {
    return null;
  }
  if (loading) {
    return null;
  }
  var onClick = function onClick(event) {
    event.preventDefault();
    setOpenMobileMenu(true);
  };
  try {
    icon = iconName && TDSIcons[iconName] ? TDSIcons[iconName] : customIcon;
  } catch (error) {
    return null;
  }
  var className = classnames(Styles['tw-react--side-nav-bar--tabs--mobile--heading'], {
    'tds--no_padding': !!(isMobileView && isSticky),
    'tds--vertical_padding--large': !!(isMobileView && !isSticky)
  });
  return selectedTab ? /*#__PURE__*/React.createElement(Heading, {
    is: "h4",
    className: className,
    onClick: onClick
  }, /*#__PURE__*/React.createElement(Icon, {
    align: "text-middle",
    data: icon,
    inline: true
  }), /*#__PURE__*/React.createElement(Text, {
    "data-test": "label-text"
  }, translations ? translations(selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.label) : selectedTab === null || selectedTab === void 0 ? void 0 : selectedTab.label), /*#__PURE__*/React.createElement(Icon, {
    data: TDSIcons === null || TDSIcons === void 0 ? void 0 : TDSIcons.iconChevronFilled180,
    inline: true,
    align: "text-middle"
  })) : null;
};

export { SelectedTab as default };
